import { useState } from "react";

export function ShowMoreContent(props) {
    const { content } = props;

    const [isShown, setShown] = useState(false)

    return(
        <div className="mtb-2">
            {
                !isShown && <div className="underline pointer" onClick={() => setShown(true)}>Show more</div>
            }
            {
                isShown &&
                <>
                    {content}
                    <div className="underline pointer" onClick={() => setShown(false)}>Show less</div>
                </>
            }
        </div>
    )
}

export default ShowMoreContent;